import React from "react";
import { Container, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

import ChatList from "./components/ChatList/ChatList";
import ChatContent from "./components/ChatContent/ChatContent";
import UserProfile from "./components/UserProfile";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: "100%",
    position: "relative",
    top: "60px",
    // paddingTop: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  main: {
      backgroundColor: "#f0f0f0",
      height: "85vh",
      borderRadius: 10,
      width: "100%",
      marginTop: "3vh",
      marginBottom: "3vh",
    //   paddingTop: theme.spacing(2),
    //   paddingBottom: theme.spacing(2),
      border: "1px solid grey"
  },
  userprofile: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  }
}));

export default function Chat() {
    const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.wrapper}>
        <Grid container className={classes.main}>
            <Grid item sm={4} lg={3}>
                <ChatList />
            </Grid>
            <Grid item sm={8} lg={6}>
                <ChatContent />
            </Grid>
            <Grid item lg={3} className={classes.userprofile}>
                <UserProfile />
            </Grid>
        </Grid>
    </Container>
  );
}
